import { render, staticRenderFns } from "./SmsTextBox.vue?vue&type=template&id=48bd84dd&scoped=true"
import script from "./SmsTextBox.vue?vue&type=script&lang=js"
export * from "./SmsTextBox.vue?vue&type=script&lang=js"
import style0 from "./SmsTextBox.vue?vue&type=style&index=0&id=48bd84dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bd84dd",
  null
  
)

export default component.exports